import {Component, OnInit} from '@angular/core';
import {AdItem} from './adds/ad-item';
import {JqueryHelperService} from '../jquery-helper.service';
import {Store} from '@ngrx/store';
import {AppState} from '../models/app.state';
import {Observable} from 'rxjs/Observable';
import {ProductService} from '../shared/product.service';
import {Product} from '../models/Product';

@Component({
  selector: 'ciu-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.css']
})
export class ContainerComponent implements OnInit {

  constructor(private jqueryHelper: JqueryHelperService,
              private store: Store<AppState>,
  private productService: ProductService) {
    this.ads$ = this.store.select( (storex) => storex.ads );
    console.log(this.ads$);
  }

  ads$: Observable<AdItem[]>;

  ngOnInit() {
    // this.productService.loadWindows();
    this.jqueryHelper.initMeanMenu();
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/container.component.ts